/**
 * Content-Design-authored copy for the /renewal-status route (TG-43,
 * Content Design Agent mandatory per the constitution's trigger table for
 * user-facing text).
 *
 * AC-28 states only the required elements for this view — that it tells a
 * read-only-session customer their renewal has been submitted and can no
 * longer be changed — not a verbatim string, so this text is
 * Content-Design-authored to satisfy exactly those elements. `helpLine` is
 * the AC-29 help line, shown since the ADR-20261008-hsvr amendment of
 * 2026-10-11.
 *
 * This view must carry no input, select or textarea element and no
 * submit action (AC-28) — `renewalStatusContent` accordingly has no field
 * label, no action label and no form-control copy of any kind, and none
 * should be added.
 */
export const renewalStatusContent = {
  heading: "Your renewal has been submitted",
  body: "Your renewal has been submitted and your answers can no longer be changed.",
  helpLine: "Need help? Contact your Account Manager.",
} as const;
